<template>
  <div class="my-4 md:my-6 overflow-x-hidden w-screen">
    <div
      class="flex gap-4 md:gap-6 overflow-x-auto justify-center px-2 md:px-0 hover:scrollbar-hide scrollbar-hide py-2"
    >
      <LinkField
        v-for="(item, index) in computedMenuItems"
        :key="getLinkPath(item.cta)"
        v-bind="item.cta"
        v-track:click="gtmData(item.originalItem, index)"
        v-track:view="gtmData(item.originalItem, index)"
        class="group flex flex-col gap-2 md:gap-2 w-20 md:w-24 min-w-20 md:min-w-24 cursor-pointer focus-visible:outline-offset-2 focus-visible:outline-2 focus-visible:outline-br-green-dark focus-visible:z-[1]"
        :active-class="'story-active'"
        :aria-current="isActive(getLinkPath(item.cta))"
        :no-tracking="true"
      >
        <div class="flex justify-center">
          <div
            :class="[
              'border rounded-full p-1 md:p-1.5',
              isActive(getLinkPath(item.cta)) ? 'border-2 border-br-green' : 'border-br-green',
            ]"
          >
            <CldnImg
              v-if="item.image.url"
              :src="item.image.url"
              :alt="item.cta.text || item.image.title || 'Category'"
              class="w-16 h-16 md:w-20 md:h-20 rounded-full"
              width="80"
              height="80"
              crop="fill"
              sizes="80px"
            />
          </div>
        </div>
        <div class="flex justify-center text-center pb-2">
          <div :class="['fluid-xs md:fluid-sm leading-tight', isActive(getLinkPath(item.cta)) ? 'font-medium' : '']">
            {{ item.cta.text || item.image.title || 'Category' }}
          </div>
        </div>
      </LinkField>
    </div>
  </div>
</template>

<script setup>
import LinkField from '@/components/common/LinkField';
import CldnImg from '@/components/CldnImg';

const props = defineProps({
  heading: {
    type: String,
    default: '',
  },
  links: {
    type: Array,
    default: () => [],
  },
  blockPosition: {
    type: Number,
    default: 0,
  },
});

const route = useRoute();
const { isExactMatch } = useUrlMatching();

const computedMenuItems = computed(() => {
  if (props.links && props.links.length > 0) {
    return props.links.map((link) => {
      const cta = Array.isArray(link.cta) && link.cta.length > 0 ? link.cta[0] : {};
      const image = Array.isArray(link.image) && link.image.length > 0 ? link.image[0] : {};

      return {
        cta,
        image,
        originalItem: link,
      };
    });
  }
});

const getLinkPath = (cta) => {
  const rawLink = cta.url || cta.element?.uri || '#';
  return rawLink.replace(/^https?:\/\/[^/]+/, '');
};

const isActive = (link) => {
  return isExactMatch(link);
};

const gtmData = (payload, index) => {
  return {
    promotion_id: payload.cta[0]?.element?.uri,
    promotion_name: [route?.name, payload.cta[0]?.text].join(' / '),
    creative_name: 'LinksDisplay_StoryStyle',
    creative_slot: [route?.name, props.blockPosition + 1, index + 1].join(' / '),
  };
};
</script>
